import {Component} from "react";
import LandingPageContainer from "./LandingPageContainer";

// Main container which hold landing page container

class LandingPage extends Component {
    render() {
        return <LandingPageContainer/>;
    }
}

export default LandingPage;
